import { z } from 'zod';
/**
 * The server's answer to "when should I ask again?", carried on every view a
 * client polls.
 *
 * It exists because the two clocks that matter are not the same clock. The
 * server re-reads Spotify on its own schedule, per DJ; a client that polls on
 * a fixed interval of its own drifts against that schedule and spends half its
 * requests collecting a sample it already has. Handing the schedule back turns
 * the client's poll into a follow-up of the server's: ask again just after the
 * next upstream read lands, whenever that is.
 *
 * `nextPollInMs` is a duration rather than an instant on purpose — a device
 * with a skewed clock still waits the right length of time, where an absolute
 * timestamp would be read against the wrong "now".
 */
export const PollSyncSchema = z
    .strictObject({
    nextPollInMs: z.number().int().nonnegative(),
    /**
     * The cadence this surface settles at once the schedules are in step. The
     * freshness cue measures staleness against it, so a single short "come
     * back in half a second" cannot read as everything having gone stale.
     */
    intervalMs: z.number().int().positive(),
})
    .readonly();
//# sourceMappingURL=sync.js.map